import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useUser } from '@/hooks/auth/use-user';

/**
 * Hook to fetch research directly assigned to a workbook/project
 * Uses direct workbook_id filtering on workbook_research table
 */
export function useWorkbookResearch(workbookId: string) {
  const { user } = useUser();

  return useQuery({
    queryKey: ['workbook-research', workbookId, user?.id],
    queryFn: async () => {
      if (!user?.id) {
        throw new Error('User not authenticated');
      }

      const { data, error } = await supabase
        .from('workbook_research')
        .select('*')
        .eq('workbook_id', workbookId)
        .eq('user_id', user.id)
        .is('deleted_at', null)
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching workbook research:', error);
        throw error;
      }

      return data || [];
    },
    enabled: !!user?.id && !!workbookId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}